/* eslint-disable max-lines */
/* eslint-disable no-underscore-dangle */
/* eslint-disable extra-rules/no-commented-out-code */
// 9fbef606107a605d69c0edbcd8029e5d
import getWishLists from '@tcp/core/src/queries/getWishList.query.graphql';
import removeOosItemFromWishlist from '@tcp/core/src/queries/removeOosItemFromWishlist.query.graphql';
import moveItemToWishlist from '@tcp/core/src/queries/moveItemToWishlist.query.graphql';
import deleteWishlist from '@tcp/core/src/queries/deleteWishlist.query.graphql';
import updateWishlist from '@tcp/core/src/queries/updateWishlist.query.graphql';
import addWishList from '@tcp/core/src/queries/addWishList.query.graphql';
import addItemInWishlist from '@tcp/core/src/queries/addItemInWishlist.query.graphql';
import getWishlistById from '@tcp/core/src/queries/getWishlistById.query.graphql';
import getWishListsAndWishlistById from '@tcp/core/src/queries/getWishListsAndWishlistById.query.graphql';
import getPublicWishlistItems from '@tcp/core/src/queries/getPublicWishlistItems.query.graphql';
import { getAPIConfig, getBrand, parseBoolean, getPlaceSiteId } from '@tcp/core/src/utils';
import {
  responseContainsErrors,
  ServiceResponseError,
  getFormattedError,
} from '@tcp/core/src/utils/errorMessage.util';
import logger from '@tcp/core/src/utils/loggerInstance';
import {
  isBopisProduct,
  isBossProduct,
} from '@tcp/core/src/components/features/browse/ProductListingPage/util/utility';
import removeItemFromWishList from '@tcp/core/src/queries/removeItemFromWishList.query.graphql';
import {
  executeStatefulAPICall,
  executeStatefulGraphQLQuery,
  initiateApiCall,
} from '../../handler';
import endpoints from '../../endpoints';
import { imageGenerator } from '../SFCC/CartItemTile';
import { getInfluencerTags, getInfluencerPicks } from './productParser';

const FAKE_WISHLIST_ID = 'fake_sv2a9';

export const AVAILABILITY = {
  OK: 'OK',
  SOLDOUT: 'SOLDOUT',
  UNAVAILABLE: 'UNAVAILABLE',
  REQ_QTY_UNAVAILABLE: 'REQ_QTY_UNAVAILABLE',
  BOSSINELIGIBLE: 'BOSSINELIGIBLE',
  SUGGESTED: 'SUGGESTED', // REVIEW: we need it to control an state to favorite's item (favorites' page).
};

const addItemToWishlist = (wishlistDetails) => {
  const { wishListId, quantity, uniqueId, errorMapping } = wishlistDetails;
  return executeStatefulGraphQLQuery({
    query: addItemInWishlist,
    variables: {
      addItemToWishListRequest: {
        priority: 1,
        public: true,
        productId: uniqueId,
        quantity: parseFloat(quantity),
        wishListId,
      },
    },
    header: {
      'brand-id': getBrand(),
    },
    type: 'mutation',
    fetchPolicy: 'no-cache',
  })
    .then((res) => {
      // if (this.apiHelper.responseContainsErrors(res)) {
      //   TODO - in case of error - handle it - throw new ServiceResponseError(res);
      // }

      const newItem = res?.data?.addItemToWishList;
      return {
        newItemId: newItem && newItem?.id,
        productId: newItem && newItem.productId,
        favoritedCount: newItem && newItem?.favCount,
      };
    })
    .catch((err) => {
      const errorMssg = getFormattedError(err, errorMapping, true);
      return {
        errorMessage:
          (errorMssg && errorMssg.errorMessages && errorMssg.errorMessages._error) ||
          (err && err.errorResponse && err.errorResponse.errorMessage) ||
          (errorMapping && errorMapping.DEFAULT) ||
          '',
      };
    });
};

/**
 * @function getUserWishLists
 * @see https://childrensplace.atlassian.net/wiki/display/DT/TCP+API+Specifications?preview=/44072969/68038386/TCP%20-%20API%20Design%20Specification%20-%20Category-CART_getListofWishList_v1.docx
 */
export const getUserWishLists = (userName) => {
  const { siteId, webAppDomain } = getAPIConfig();
  const assetHost =
    (typeof window !== 'undefined' && window.location && window.location.origin) || webAppDomain;
  return executeStatefulGraphQLQuery({
    query: getWishLists,
    fetchPolicy: 'no-cache',
  })
    .then((res) => {
      let wishlists = [];
      if (responseContainsErrors(res)) {
        throw new ServiceResponseError(res);
      }
      if (res.data && res.data.getAllWishList === null) {
        wishlists.push({
          id: FAKE_WISHLIST_ID,
          displayName: `${userName}'s Favorites`,
          isDefault: true,
          itemsCount: 0,
          shareableLink: '',
        });
        // Backend won't create a default one, so we need to mimic one
        return wishlists;
      }
      let containsDefaultWishlist = false;
      wishlists = res.data.getAllWishList.map((wishlist) => {
        containsDefaultWishlist = containsDefaultWishlist || wishlist.status === 'Default';
        const itemNumber = wishlist?.customerProductListItems?.length || 0;
        return {
          id: `${wishlist?.id}`,
          displayName: wishlist?.name || `${userName}`,
          productsList: wishlist?.customerProductListItems || [],
          isDefault: false,
          itemsCount: itemNumber,
          shareableLink: `${assetHost}/${siteId}/favorites?wishlistId=${
            wishlist.id
          }&guestAccessKey=${true}`,
        };
      });
      return wishlists;
    })
    .catch(() => {
      return [
        {
          id: FAKE_WISHLIST_ID,
          displayName: `${userName}'s Favorites`,
          isDefault: true,
          itemsCount: 0,
          shareableLink: '',
        },
      ];
    });
};

const getClearanceItem = (item, isUSStore) => {
  return isUSStore
    ? (item.product.c_TCPProductIndUSStore || '').toLowerCase() === 'clearance'
    : (item.product.c_TCPProductIndCanadaStore || '').toLowerCase() === 'clearance';
};

const newArrivalItem = (item, isUSStore) => {
  return isUSStore
    ? (item.product.c_TCPProductIndUSStore || '').toLowerCase() === 'new arrivals'
    : (item.product.c_TCPProductIndCanadaStore || '').toLowerCase() === 'new arrivals';
};

const getFinalPDPUrl = (item) => {
  let pdpURL;
  if (getBrand()?.toUpperCase() === item?.product?.brand) {
    pdpURL = `us/p/${item.product.master.masterId}`;
  } else {
    pdpURL = `/p/${item.product.master.masterId}`;
  }
  return pdpURL;
};
const filterWishList = (wishlist) => {
  return wishlist.filter((item) => {
    const { product = '' } = item;
    return !!product;
  });
};

const parseWishListResponse = (wishListId, wishlist, wishListName, isCanada, userName) => {
  const { isUSStore } = getAPIConfig();
  let filteredWL = wishlist;
  filteredWL = filterWishList(filteredWL);
  const wishlistObj = {};
  const items = filteredWL?.map((item) => {
    const productImages = imageGenerator(item.product.master.masterId)
      ? imageGenerator(item.product.master.masterId).productImages[500]
      : '';
    const processedWishlistItem = {
      productInfo: {
        generalProductId: item.product.id,
        name: item?.product?.name,
        isGiftCard: item?.product?.c_isGiftCard,
        pdpUrl: getFinalPDPUrl(item),
        listPrice: item?.product?.price,
        // TODO render offer price for Canada and US
        // offerPrice: isCanada ? item.OfferPriceCAD : item.OfferPriceUS,
        offerPrice: item?.product?.price,
        seoToken: item?.product?.pageKeywords || '',
      },
      imageURL: productImages,
      fromFavorites: true,
      skuInfo: {
        skuId: item.product.id,
        upc: item.product.upc,
        imageUrl: productImages,

        colorProductId: item.product.id,
        color: {
          name: item.product.c_TCPColor,
          imagePath: productImages,
        },
        fit: item.product.c_fit,
        size: item.product.c_size,
        productId: item.product.id,
        prodPartNo: item?.product?.master?.masterId,
        variantNo: item?.product?.manufacturerSku,
      },
      itemInfo: {
        itemId: item.id,
        quantity: parseInt(item.quantity, 10),
        isTCP: item?.product.brand === 'TCP',
        brand: item?.product.brand,
        availability: item?.product.inventory?.ats !== 0 ? AVAILABILITY.OK : AVAILABILITY.SOLDOUT,
        keepAlive: true,
      },
      imagesByColor: {
        [item.product.id]: {
          extraImages: [productImages],
        },
      },
      miscInfo: {
        // when an item is added to the wishlist, backend choses a random sku,
        // and we need to pass that random sku when moving to a different wishlist.
        // since that is the case we also need to flag when to show the quivkiew for such item
        isShowQuickView: parseBoolean(item.isProduct),
        isBopisEligible: !!item.c_TCPWebOnlyFlagUSStore,
        itemTCPROPISUSStore: null,
        clearanceItem: getClearanceItem(item, isUSStore),
        newArrivalItem: newArrivalItem(item, isUSStore),
      },
      quantityPurchased: parseInt(item.purchasedQuantity, 10),
    };
    wishlistObj[item.product.id] = { productPartNo: item.product.id, itemId: item.id };
    return processedWishlistItem;
  });
  return {
    id: wishListId,
    displayName: wishListName,
    creatorName: userName,
    isDefault: filteredWL?.default === 'true',
    items,
    wishlistObj,
  };
};

/**
 * @function getWishListbyId
 * @param {String} wishListId - Id of the wishlist you are moving the item from
 * @param {String} userName - Backend is not going to return a default wishlist, so if the service returns nothing we need to fake one.
 * @param {String} guestAccessKey - guestAccessKey for shared wishlist
 * @see https://childrensplace.atlassian.net/browse/DT-24970
 * @see https://childrensplace.atlassian.net/wiki/display/DT/TCP+API+Specifications?preview=/44072969/69013363/TCP%20-%20API%20Design%20Specification%20-%20Category-Checkout_getWishListById_v1.docx
 */
export const getWishListbyId = ({ wishListId, wishListName, userName, isCanada }) => {
  if (wishListId === FAKE_WISHLIST_ID) {
    return {
      id: FAKE_WISHLIST_ID,
      displayName: `${userName}'s Favorites`,
      creatorName: userName,
      isDefault: true,
      items: [],
    };
  }

  return executeStatefulGraphQLQuery({
    query: getWishlistById,
    variables: {
      getWishlistItemsWishlistId: wishListId,
    },
    fetchPolicy: 'no-cache',
  })
    .then((res) => {
      if (responseContainsErrors(res)) {
        throw new ServiceResponseError(res);
      } else {
        if (res.data?.getWishlistItems?.customerProductListItems === null) {
          return {
            id: wishListId,
            displayName: wishListName || `${userName}`,
            creatorName: userName,
            isDefault: true,
            items: [],
          };
        }
        return parseWishListResponse(
          wishListId,
          res.data?.getWishlistItems.customerProductListItems,
          wishListName || `${userName}`,
          isCanada,
          userName
        );
      }
    })
    .catch((err) => {
      logger.error('err', err);
      return {
        id: wishListId || '',
        displayName: wishListName || `${userName}'s Favorites`,
        creatorName: userName,
        isDefault: true,
        items: [],
      };
    });
};

/**
 * @function getWishListsAndWishlistWithId
 */
export const getWishListsAndWishlistWithId = ({ userName, wishlistId, wishlistName, isCanada }) => {
  const { siteId, webAppDomain } = getAPIConfig();
  const assetHost =
    (typeof window !== 'undefined' && window.location && window.location.origin) || webAppDomain;
  return executeStatefulGraphQLQuery({
    query: getWishListsAndWishlistById,
    variables: { wishlistId },
    fetchPolicy: 'no-cache',
  })
    .then((res) => {
      let wishlists = [];
      let wishlistById = {};

      // Wishlists
      if (responseContainsErrors(res)) {
        throw new ServiceResponseError(res);
      }
      if (res.data && res.data.getAllWishList === null) {
        wishlists.push({
          id: FAKE_WISHLIST_ID,
          displayName: `${userName}'s Favorites`,
          isDefault: true,
          itemsCount: 0,
          shareableLink: '',
        });
      }
      wishlists = res.data.getAllWishList.map((wishlist) => ({
        id: `${wishlist?.id}`,
        displayName: wishlist?.name || `${userName}`,
        productsList: wishlist?.customerProductListItems || [],
        isDefault: false,
        itemsCount: wishlist?.customerProductListItems?.length || 0,
        shareableLink: `${assetHost}/${siteId}/favorites?wishlistId=${
          wishlist.id
        }&guestAccessKey=${true}`,
      }));

      if (wishlistId === FAKE_WISHLIST_ID) {
        wishlistById = {
          id: FAKE_WISHLIST_ID,
          displayName: `${userName}'s Favorites`,
          creatorName: userName,
          isDefault: true,
          items: [],
        };
      }
      if (res.data?.getWishlistItems?.customerProductListItems === null) {
        wishlistById = {
          id: wishlistId,
          displayName: wishlistName || `${userName}`,
          creatorName: userName,
          isDefault: true,
          items: [],
        };
      } else {
        wishlistById = parseWishListResponse(
          wishlistId,
          res.data?.getWishlistItems.customerProductListItems,
          wishlistName,
          isCanada,
          userName
        );
      }

      return { wishlists, wishlistById };
    })
    .catch((err) => {
      logger.error('err', err);
      if (
        err &&
        err.response &&
        err.response.body &&
        err.response.body.errorCode === 'NO_WISHLIST_FOUND'
      ) {
        return {
          wishlists: [
            {
              id: FAKE_WISHLIST_ID,
              displayName: `${userName}'s Favorites`,
              isDefault: true,
              itemsCount: 0,
              shareableLink: '',
            },
          ],
          wishlistById: {
            id: wishlistId,
            displayName: wishlistName || `${userName}`,
            creatorName: userName,
            isDefault: true,
            items: [],
          },
        };
      }

      throw getFormattedError(err);
    });
};

export const getPublicWishListItems = ({ wishListId, wishListName, userName, isCanada }) => {
  if (wishListId === FAKE_WISHLIST_ID) {
    return {
      id: FAKE_WISHLIST_ID,
      displayName: `${userName}'s Favorites`,
      creatorName: userName,
      isDefault: true,
      productList: [],
    };
  }
  return executeStatefulGraphQLQuery({
    query: getPublicWishlistItems,
    variables: {
      wishlistId: wishListId,
    },
    type: 'query',
    fetchPolicy: 'no-cache',
  })
    .then((res) => {
      if (responseContainsErrors(res)) {
        throw new ServiceResponseError(res);
      } else {
        if (res.data?.getPublicWishlistItems?.customerProductListItems === null) {
          return {
            id: wishListId,
            displayName: wishListName || `${userName}`,
            creatorName: userName,
            isDefault: true,
            items: [],
          };
        }
        return parseWishListResponse(
          wishListId,
          res.data?.getPublicWishlistItems?.customerProductListItems,
          res.data?.getPublicWishlistItems?.name,
          isCanada,
          userName
        );
      }
    })
    .catch((err) => {
      throw getFormattedError(err);
    });
};

/*
 * @function getProductsPrices
 * @summary Auxiliar method to retrieve prices for product recommendations. It returns prices for specific product ids
 * @param {Array[String]} productIds - the ids of all the products to get prices for
 */
export const getProductsPrices = (productIds, xappURLConfig) => {
  const payload = {
    body: {
      id: productIds.join(','),
      fields:
        'min_offer_price,min_list_price,TCPWebOnlyFlagUSStore,TcpBossCategoryDisabled,TcpBossProductDisabled,TCPProductIndUSStore,TCPProductIndCanadaStore,influencer_tags,influencer_pick',
    },
    webService: endpoints.getProductDetails,
  };
  return initiateApiCall(payload, null, xappURLConfig)
    .then((res) => {
      if (responseContainsErrors(res)) {
        throw new ServiceResponseError(res);
      } else {
        const price = {};
        const { isUSStore } = getAPIConfig();
        if (res.body && res.body.response) {
          res.body.response.products.forEach((product) => {
            price[product.uniqueId] = {
              listPrice:
                (product.min_list_price === product.min_offer_price
                  ? product.min_offer_price
                  : product.min_list_price) || 0,
              offerPrice: product.min_offer_price || 0,
              isBopisEligible: isBopisProduct(isUSStore, product),
              isBossEligible: isBossProduct({
                bossCategoryDisabled: product.TcpBossCategoryDisabled,
                bossProductDisabled: product.TcpBossProductDisabled,
              }),
              clearanceItem: isUSStore
                ? product.TCPProductIndUSStore === 'Clearance'
                : product.TCPProductIndCanadaStore === 'Clearance',
              influencerTags: getInfluencerTags(product),
              influencerPicks: getInfluencerPicks(product),
            };
          });
        }
        return price;
      }
    })
    .catch((err) => {
      throw getFormattedError(err);
    });
};

/**
 * @function createWishList
 * @param {string} wishlistId - The is of the wishlist you would like to create
 * @param {string} isDefault - flags if this should become the favorite wishlist
 * @see https://childrensplace.atlassian.net/wiki/display/DT/TCP+API+Specifications?preview=/44072969/69011584/TCP%20-%20API%20Design%20Specification%20-%20Category-Checkout_createWishList_v1.docx
 */
export const createWishList = (wishlistName, isDefault) => {
  const payload = {
    name: wishlistName || 'random',
    c_state: isDefault ? 'Default' : 'Active',
  };

  return executeStatefulGraphQLQuery({
    query: addWishList,
    variables: {
      createWishListRequest: payload,
    },
    type: 'mutation',
    fetchPolicy: 'no-cache',
  })
    .then((res) => {
      if (responseContainsErrors(res)) {
        throw new ServiceResponseError(res);
      } else {
        return {
          id: res.data.createWishList.id,
          success: true,
        };
      }
    })
    .catch((err) => {
      throw getFormattedError(err);
    });
};

export const moveItemToNewWishList = (
  formData,
  activeWishlistId,
  activeWishlistItem,
  errorMapping
) => {
  const args = {
    fromWishListId: activeWishlistId,
    toWishListId: formData.toWishListId,
    generalProductId: activeWishlistItem.productInfo.generalProductId,
    skuId: activeWishlistItem && activeWishlistItem.skuInfo.skuId,
    wishListItemId: formData.itemId,
    quantity: activeWishlistItem && activeWishlistItem.itemInfo.quantity,
    isProduct: !activeWishlistItem.skuInfo.size,
  };

  return executeStatefulGraphQLQuery({
    query: moveItemToWishlist,
    variables: {
      moveItemToWishListRequest: {
        addToWishlistId: args.toWishListId,
        itemId: args.wishListItemId,
        productId: args.isProduct ? args.generalProductId : args.skuId,
        removeFromWishlistId: args.fromWishListId,
      },
    },
    type: 'mutation',
    fetchPolicy: 'no-cache',
  })
    .then((res) => {
      if (responseContainsErrors(res)) {
        throw new ServiceResponseError(res);
      } else {
        return { success: true };
      }
    })
    .catch((err) => {
      logger.error('err', err);
      const errorMssg = getFormattedError(err, errorMapping, true);
      return {
        errorMessage:
          (errorMssg && errorMssg.errorMessages && errorMssg.errorMessages._error) ||
          (err && err.errorResponse && err.errorResponse.errorMessage) ||
          (errorMapping && errorMapping.DEFAULT) ||
          '',
      };
    });
};

/**
 * @function deleteWishList
 * @param {string} wishlistId - The is of the wishlist you would like to share
 * @see https://childrensplace.atlassian.net/wiki/display/DT/TCP+API+Specifications?preview=/44072969/69011822/TCP%20-%20API%20Design%20Specification%20-%20Category-Checkout_deleteWishList_v1.docx
 */
export const deleteWishList = (wishlistId) => {
  return executeStatefulGraphQLQuery({
    query: deleteWishlist,
    variables: {
      deleteWishListWishlistId: wishlistId,
    },
    type: 'mutation',
    fetchPolicy: 'no-cache',
  })
    .then((res) => {
      if (responseContainsErrors(res)) {
        throw new ServiceResponseError(res);
      } else {
        return {
          success: true,
          uniqueID: res.data.deleteWishList.wishListId,
        };
      }
    })
    .catch((err) => {
      throw getFormattedError(err);
    });
};

/**
 * @function updateWishlistName
 * @summary This API is used to update your wishlist name.
 * @param {String} newName - The wishlist's name that it will now be refered to
 * @param {String} wishlistId - Id of the wishlist you want to update
 * @param {Boolean} isDefault - Whether to make the wishlist as the default one
 * @see https://childrensplace.atlassian.net/wiki/display/DT/TCP+API+Specifications?preview=/44072969/68045657/TCP%20-%20API%20Design%20Specification%20-%20Category-CART_EditWishlist_v3.docx
 */
export const updateWishlistName = (wishlistId, newName, isDefault) => {
  return executeStatefulGraphQLQuery({
    query: updateWishlist,
    variables: {
      updateWishListRequest: {
        c_state: isDefault ? 'default' : 'active',
        name: newName,
        public: true,
      },
      updateWishListWishlistId: wishlistId,
    },
    type: 'mutation',
    fetchPolicy: 'no-cache',
  })
    .then((res) => {
      if (responseContainsErrors(res)) {
        throw new ServiceResponseError(res);
      } else {
        return {
          success: true,
        };
      }
    })
    .catch((err) => {
      throw getFormattedError(err);
    });
};

/**
 * @function deleteWishListItem
 * @param {string} wishlistId - id of the wishlist you would like to share
 * @param {string} itemId - id of the item you want to remove
 * @see https://childrensplace.atlassian.net/wiki/display/DT/TCP+API+Specifications?preview=/44072969/69011822/TCP%20-%20API%20Design%20Specification%20-%20Category-Checkout_deleteWishList_v1.docx
 */
export const deleteWishListItem = (externalId, itemId, productId) => {
  return executeStatefulGraphQLQuery({
    query: removeItemFromWishList,
    variables: {
      wishListId: externalId,
      itemId,
      productId,
    },
    type: 'mutation',
  })
    .then((res) => {
      if (res.data?.errors) {
        throw new ServiceResponseError(res);
      } else {
        const removedItem = res?.data?.removeItemFromWishList;
        return {
          res: res.data,
          removedItemId: removedItem && removedItem?.itemId,
          favoritedCount: removedItem && removedItem?.favCount,
          success: true,
        };
      }
    })
    .catch((err) => {
      throw getFormattedError(err);
    });
};

/**
 * @function shareWishlistByEmail
 * @param {string} wishlistId - The is of the wishlist you would like to share
 * @param {string} from - The current users email address
 * @param {array<string>} to - An array of strings, each string being an email address
 * @param {string} message - A string message to be sent
 * @see https://childrensplace.atlassian.net/wiki/display/DT/TCP+API+Specifications?preview=/44072969/69075593/TCP%20-%20API%20Design%20Specification%20-%20Category-Checkout_shareWishList_v1.docx
 */
export const shareWishlistByEmail = (wishlistId, from, to, subject, message) => {
  const shareWishlistAPI = {
    ...endpoints.shareWishListForUser,
    URI: `${endpoints.shareWishListForUser.URI}/${wishlistId}`,
  };

  const payload = {
    header: {
      externalId: wishlistId,
      type: 'email',
      siteId: getPlaceSiteId(),
    },
    body: {
      recipientEmail: to.map((email) => ({ email: (email || '').trim() })),
      senderEmail: from,
      subject,
      message,
    },
    webService: shareWishlistAPI,
  };

  return executeStatefulAPICall(payload)
    .then((res) => {
      if (responseContainsErrors(res)) {
        throw new ServiceResponseError(res);
      } else {
        return {
          successful: true,
        };
      }
    })
    .catch((err) => {
      throw getFormattedError(err);
    });
};

export const removeOOSItemFromWishlist = ({ wishListId, wishListName, userName, isCanada }) => {
  if (wishListId === FAKE_WISHLIST_ID) {
    return {
      id: FAKE_WISHLIST_ID,
      displayName: `${userName}'s Favorites`,
      creatorName: userName,
      isDefault: true,
      items: [],
    };
  }
  return executeStatefulGraphQLQuery({
    query: removeOosItemFromWishlist,
    variables: {
      wishlistId: wishListId,
    },
    fetchPolicy: 'no-cache',
  })
    .then((res) => {
      if (responseContainsErrors(res)) {
        throw new ServiceResponseError(res);
      } else {
        if (res.data?.removeOOSItemFromWishlist?.customerProductListItems === null) {
          return {
            id: wishListId,
            displayName: wishListName,
            creatorName: userName,
            isDefault: true,
            items: [],
          };
        }
        return parseWishListResponse(
          wishListId,
          res.data?.removeOOSItemFromWishlist.customerProductListItems,
          wishListName || '',
          isCanada,
          userName
        );
      }
    })
    .catch((err) => {
      if (err) {
        return {
          id: wishListId || '',
          displayName: wishListName || `${userName}'s Favorites`,
          creatorName: userName,
          isDefault: true,
          items: [],
        };
      }
      throw getFormattedError(err);
    });
};
export default addItemToWishlist;
